
(function () {
  'use strict';

  function init() {
    if (window.innerWidth < 769) return;

    var menuContent = document.querySelector('.main-menu__content');
    var primaryNav  = document.querySelector('.main-menu__content > nav[aria-label="Primary"]');
    var ul          = document.querySelector('ul.main-nav');
    if (!menuContent || !primaryNav || !ul) return;
    if (menuContent.querySelector('.nav-scroll-btn')) return;

    var megaNavPairs = []; 

    var items = ul.querySelectorAll('li > details.js-mega-nav');
    items.forEach(function(details) {
      var mn = details.querySelector('.mega-nav');
      if (!mn) return;
      var li = details.parentElement;

          // Fix: panel is moved outside the header, so the theme treats focus on its links as "focus left the menu" and closes it before the click lands. Stop that focus event reaching the theme.
              mn.addEventListener('focusin', function (e) { e.stopPropagation(); });
      document.body.appendChild(mn);
      megaNavPairs.push({ details: details, li: li, megaNav: mn });
    });

    function positionMegaNavs() {
      var navBottom  = menuContent.getBoundingClientRect().bottom;
      var scrollbarW = window.innerWidth - document.documentElement.clientWidth;
      var navWidth   = window.innerWidth - scrollbarW;

      megaNavPairs.forEach(function(pair) {
        var mn = pair.megaNav;
        mn.style.setProperty('position', 'fixed', 'important');
        mn.style.setProperty('top', navBottom + 'px', 'important');
        mn.style.setProperty('left', '0px', 'important');
        mn.style.setProperty('width', navWidth + 'px', 'important');
        mn.style.setProperty('margin', '0', 'important');
        mn.style.setProperty('transform', 'none', 'important');
      });
    }

    positionMegaNavs();
    window.addEventListener('resize', positionMegaNavs);
    window.addEventListener('scroll', positionMegaNavs, { passive: true });


    var observer = new MutationObserver(function() {
      megaNavPairs.forEach(function(pair) {
        var isOpen = pair.details.classList.contains('is-open');
        if (isOpen) {
          pair.megaNav.style.setProperty('visibility', 'visible', 'important');
          pair.megaNav.style.setProperty('opacity', '1', 'important');
          pair.megaNav.style.setProperty('transform', 'translateY(0)', 'important');
          positionMegaNavs();
        } else {
          pair.megaNav.style.setProperty('visibility', 'hidden', 'important');
          pair.megaNav.style.setProperty('opacity', '0', 'important');
          pair.megaNav.style.setProperty('transform', 'translateY(-10px)', 'important');
        }
      });
    });

    observer.observe(ul, {
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });

    function makeBtn(dir) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'nav-scroll-btn nav-scroll-btn--' + dir;
      btn.setAttribute('aria-label', 'Scroll navigation ' + dir);
      btn.innerHTML = dir === 'left'
        ? '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg>'
        : '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M9 18l6-6-6-6"/></svg>';
      return btn;
    }

    var btnLeft  = makeBtn('left');
    var btnRight = makeBtn('right');
    var secondaryNav = menuContent.querySelector('.secondary-nav-container');

    menuContent.insertBefore(btnLeft, primaryNav);
    if (secondaryNav) {
      menuContent.insertBefore(btnRight, secondaryNav);
    } else {
      menuContent.insertBefore(btnRight, primaryNav.nextSibling);
    }

    var currentX = 0;
    var STEP     = 200;

    function getMaxScroll() {
      return Math.max(0, ul.scrollWidth - primaryNav.getBoundingClientRect().width);
    }

    function slideTo(x) {
      var max  = getMaxScroll();
      currentX = Math.min(0, Math.max(-max, x));
      ul.style.transform = 'translateX(' + currentX + 'px)';
      btnLeft.classList.toggle('nav-scroll-btn--faded',  currentX >= 0);
      btnRight.classList.toggle('nav-scroll-btn--faded', currentX <= -max + 1);
    }

    btnLeft.addEventListener('click', function (e) {
      e.preventDefault();
      slideTo(currentX + STEP);
    });

    btnRight.addEventListener('click', function (e) {
      e.preventDefault();
      slideTo(currentX - STEP);
    });

    window.addEventListener('resize', function () { slideTo(currentX); });

    slideTo(0);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
// Ready Meals dropdown links open the Ready Meals page with that collection in the product grid
(function () { var H = ['ready-meal-bundles', 'single-serve-meals', 'family-meals', 'kids-meals', 'soups-broths', 'dessert']; function handleOf(a) { var m = a.pathname.match(/^\/collections\/([^\/]+)\/?$/); return m && H.indexOf(m[1]) > -1 && !a.search ? m[1] : null; } function fix() { document.querySelectorAll('.cc-header ul, .mega-nav ul, .main-menu ul').forEach(function (ul) { var links = [].slice.call(ul.querySelectorAll('a[href]')).filter(handleOf); var found = {}; links.forEach(function (a) { found[handleOf(a)] = 1; }); if (Object.keys(found).length < 2) return; links.forEach(function (a) { a.href = '/collections/' + handleOf(a) + '?view=ready-meals#c8-shop'; }); }); } if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', fix); } else { fix(); } window.addEventListener('load', fix); })();
(function () { /* Groceries: every link in the Groceries dropdown, plus any link to the Groceries collection, opens the Groceries bubbles page (view=groceries) */ function fixG() { [].slice.call(document.querySelectorAll('.mega-nav, ul.main-nav > li > details')).filter(function (p) { return p.querySelector('a[href="/collections/grocery"]') && p.querySelector('a[href="/collections/fruit-veg"]'); }).forEach(function (p) { p.querySelectorAll('a[href^="/collections/"]').forEach(function (a) { if (!a.search && /^\/collections\/[^\/]+\/?$/.test(a.pathname)) a.href = a.pathname + '?view=groceries' + (/^\/collections\/grocery\/?$/.test(a.pathname) ? '' : '#c8-shop'); }); }); document.querySelectorAll('a[href="/collections/grocery"]').forEach(function (a) { a.href = '/collections/grocery?view=groceries'; }); } if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', fixG); } else { fixG(); } window.addEventListener('load', fixG); })();
// Bulk & Bundle: every link to Bulk & Bundle or one of its bundle collections (header dropdown, mobile menu, anywhere else) opens the Bulk & Bundle bubbles page (view=bulk-bundle) with that bundle chosen
(function () { var H = ['bulk-bundle', 'everyday-essentials', 'breakfast-bundles', 'dinner-bundles', 'entertainment-bundles']; function handleOf(a) { var m = a.pathname.match(/^\/collections\/([^\/]+)\/?$/); return m && H.indexOf(m[1]) > -1 && !a.search ? m[1] : null; } function fixB() { [].slice.call(document.querySelectorAll('a[href]')).filter(handleOf).forEach(function (a) { a.href = '/collections/' + handleOf(a) + '?view=bulk-bundle' + (handleOf(a) === 'bulk-bundle' ? '' : '#c8-shop'); }); } if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', fixB); } else { fixB(); } window.addEventListener('load', fixB); })(); /* Links ending in #shopall: once the page has finished loading, line the bubble bar up under the header (the browser's own early jump can land in the product grid). Does nothing if the shopper has already started scrolling. */ (function () { if (location.hash !== '#c8-shop' && location.hash !== '#shopall') return; var moved = false; function stop() { moved = true; } ['wheel', 'touchstart', 'keydown', 'mousedown'].forEach(function (ev) { window.addEventListener(ev, stop, { passive: true, once: true }); }); function go() { if (moved) return; var a = document.getElementById('shopall'); if (!a) return; var sec = a.closest('[id^="shopify-section"]') || a; var prev = sec.previousElementSibling; var y; if (getComputedStyle(sec).position === 'sticky' && prev) { var op = sec.style.position; sec.style.position = 'static'; y = sec.getBoundingClientRect().top + window.pageYOffset; sec.style.position = op; y = y - (window.c8CompactHeaderBottom ? window.c8CompactHeaderBottom() : (parseFloat(getComputedStyle(sec).top) || 0)); } else { y = a.getBoundingClientRect().top + window.pageYOffset - (parseFloat(getComputedStyle(a).scrollMarginTop) || 0); } window.scrollTo(0, Math.max(0, y)); } function run() { go(); } if (document.readyState === 'complete') { run(); } else { window.addEventListener('load', run); } })(); /* Keep the bubble bar pinned directly under the visible header (the header hides its menu row when scrolling down, so a fixed offset leaves a gap). Also tells the landing script where the header will end once compact. */ (function () { var grp; function setTop() { grp = grp || document.querySelector('.cc-header--sticky'); var a = document.getElementById('shopall'); if (!a) return; var sec = a.closest('[id^="shopify-section"]'); if (!sec || getComputedStyle(sec).position !== 'sticky') return; var b = 0; if (grp) { var p = getComputedStyle(grp).position; if (p === 'sticky' || p === 'fixed') b = Math.max(0, grp.getBoundingClientRect().bottom); } sec.style.top = Math.max(0, b - 1) + 'px'; } var until = 0; function loop() { setTop(); if (Date.now() < until) requestAnimationFrame(loop); } function kick() { var running = Date.now() < until; until = Date.now() + 1500; if (!running) requestAnimationFrame(loop); } window.addEventListener('scroll', kick, { passive: true }); window.addEventListener('resize', kick); window.addEventListener('load', kick); if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', kick); } else { kick(); } window.c8CompactHeaderBottom = function () { var g = document.querySelector('.cc-header--sticky'); if (!g) return 0; var p = getComputedStyle(g).position; if (p !== 'sticky' && p !== 'fixed') return 0; var nav = g.querySelector('.main-menu'); var navH = nav ? nav.offsetHeight : 0; return (parseFloat(getComputedStyle(g).top) || 0) + g.offsetHeight - navH; }; })();